import React, { useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { user, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin Login — Je Ke Pictures";
  }, []);

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin");
  }, [user, loading, navigate]);

  const startAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="jk-glass max-w-md w-full p-10 text-center">
        <div className="font-cinzel text-[0.65rem] tracking-[0.5em] text-[color:var(--jk-gold)] mb-3">— ADMIN</div>
        <h1 className="font-cinzel font-bold text-3xl mb-4">Sign in</h1>
        <p className="text-[color:var(--jk-muted)] text-sm mb-8">
          Access restricted to authorised Je Ke Pictures staff. Sign in with your Google account.
        </p>
        {user && !user.is_admin && (
          <div className="mb-6 p-3 border border-red-900/50 text-red-300 text-sm" data-testid="admin-forbidden-msg">
            Signed in as {user.email}. This account is not authorised as admin.
          </div>
        )}
        <button
          onClick={startAuth}
          className="jk-btn jk-btn-solid w-full justify-center"
          data-testid="google-login-btn"
        >
          Continue with Google
        </button>
        <Link to="/" className="jk-link inline-block mt-6 text-xs">← Back to site</Link>
      </div>
    </div>
  );
}
